module.exports = __webpack_public_path__ + "media/images/favicons/luconnect-6b47c95d924fc5379858046cc2eead387cced242727ed9cebb2687539edc377c.ico";